import { useEffect, useState } from "react";
import { api } from "../../../api";
import { Button } from "../../../components/ui/button";
import { centsToCurrency } from "../../utils/money";
import { useLanguage } from "../../../contexts/LanguageContext";
import { landingLabels } from "../labels";

export function PricingSection(
  {
    onSelectPlan,
  }: { onSelectPlan?: (plan: "monthly" | "semiannual" | "annual") => void }
) {
  const { lang } = useLanguage();
  const t = landingLabels[lang].pricing;
  const [pricing, setPricing] = useState<
    | null
    | {
        currency: string;
        base: number;
        monthly: { amount: number; price_id: string | null; available: boolean };
        semiannual: { amount: number; price_id: string | null; available: boolean };
        annual: { amount: number; price_id: string | null; available: boolean };
      }
  >(null);

  useEffect(() => {
    api.getSubscriptionPricing().then(res => {
      if (res.ok) setPricing(res.data);
    });
  }, []);

  if (!pricing) return null;

  const allPlans: { key: "monthly" | "semiannual" | "annual"; name: string; description: string; price: number; available: boolean }[] = [
    { key: "monthly", ...t.plans.monthly, price: pricing.monthly.amount, available: pricing.monthly.available },
    { key: "semiannual", ...t.plans.semiannual, price: pricing.semiannual.amount, available: pricing.semiannual.available },
    { key: "annual", ...t.plans.annual, price: pricing.annual.amount, available: pricing.annual.available },
  ];
  const plans = allPlans.filter(p => p.available);

  return (
    <section id="pricing" className="w-full py-12">
      <div className="w-full max-w-screen-lg mx-auto px-6 text-center">
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">
          {t.title}
        </h2>
        <p className="mt-2 text-neutral-600">{t.description}</p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {plans.map(plan => (
            <div
              key={plan.key}
              className="border border-neutral-200 rounded-2xl p-6 flex flex-col items-center text-center"
            >
              <h3 className="text-lg font-medium">{plan.name}</h3>
              <p className="mt-4 text-4xl font-bold">
                {centsToCurrency(plan.price, lang)}
              </p>
              <p className="mt-2 text-sm text-neutral-600">{plan.description}</p>
              <Button
                className="mt-6 w-full"
                onClick={() => onSelectPlan?.(plan.key)}
              >
                {t.subscribe}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default PricingSection;
